"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainTable = void 0;
var React = require("react");
var SelectInput_1 = require("../../../Inputs/SelectInput/SelectInput");
var Localization_1 = require("../../../Localization");
var Styles_1 = require("./Styles");
var MainTable = function (_a) {
    var MainTableValue = _a.MainTableValue, OnMainTableChange = _a.OnMainTableChange, MainTables = _a.MainTables;
    return (React.createElement("div", null,
        React.createElement(Styles_1.HeaderLabel, { id: "FieldSelectorMainTable" }, Localization_1.strings.FieldSelector_Label_MainTable),
        React.createElement(SelectInput_1.SelectInput, { LabelledBy: "FieldSelectorMainTable", Name: "Tables", Value: MainTableValue, Options: MainTables, OnChange: OnMainTableChange })));
};
exports.MainTable = MainTable;
